"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throttleFn = void 0;
// Throttle with ensured final and immediate invocations
function throttleFn(callback, delay, { leading, trailing, } = {
    leading: true,
    trailing: true,
}) {
    let queued;
    let lastCall;
    return function invokeFn(...args) {
        const now = Date.now();
        if (trailing) {
            window.clearTimeout(queued);
            queued = undefined;
        }
        // first call or consecutives inside the allowes time window
        if (lastCall == null || now - lastCall >= delay) {
            if (leading || lastCall != null)
                callback(...args);
            lastCall = now;
        }
        else {
            if (trailing) {
                queued = window.setTimeout(() => invokeFn(...args), delay - (now - lastCall || 0));
            }
            else {
                queued = undefined;
            }
        }
    };
}
exports.throttleFn = throttleFn;
